// John Eldhose 20180523
import { RestfulGet } from './Restful';

export async function getAccount() {
  const acc = await RestfulGet('getAccount', (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return acc;
}



// WEBPACK FOOTER //
// ./src/Api/getAccount.js